import { showNotification } from '@mantine/notifications'
import dayjs from 'dayjs'
import { T } from 'components/common/T'
import i18n from 'i18next'
import { z } from 'zod'
import { api } from '..'

export const exportMeasurementsToCSVSchema = z
  .object({
    dateFrom: z.string().nullish(),
    dateTo: z.string().nullish(),
    indicatorCode: z.string().optional(),
    exportMode: z.enum(['all', 'single']).optional(),
  })
  .refine(
    data => {
      if (data.exportMode === 'single') {
        return !!data.indicatorCode
      }
      return true
    },
    {
      message: i18n.t('dashboard.indicatorRequired'),
      path: ['indicatorCode'],
    },
  )
  .refine(
    data => {
      if (data.dateFrom && data.dateTo) {
        const from = dayjs(data.dateFrom)
        const to = dayjs(data.dateTo)
        const diffInMonths = to.diff(from, 'month', true)
        return diffInMonths <= 2
      }
      return true
    },
    {
      message: i18n.t('dashboard.maxDateRangeNote'),
      path: ['dateTo'],
    },
  )

export type TExportMeasurementsToCSVFields = z.infer<
  typeof exportMeasurementsToCSVSchema
>

export const exportMeasurementsToCSV =
  ({ deviceId }: { deviceId: string }) =>
  async (data: TExportMeasurementsToCSVFields) => {
    return api
      .get(`v1/measurements/export-csv`, {
        responseType: 'blob',
        params: {
          deviceId,
          dateFrom: data?.dateFrom,
          dateTo: data?.dateTo,
          indicatorCode: data?.indicatorCode,
          timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `measurements-${deviceId}.csv`)
        document.body.appendChild(link)
        link.click()
      })
      .catch(e => {
        showNotification({
          color: 'red',
          message: <T>systemMessages.unexpectedError</T>,
        })
      })
  }
